import { defineMessage } from 'react-intl';
import styled from 'styled-components';

import discountCardBack from 'assets/rewards/discount-card-back.png';
import { useIntlContext } from 'contexts/intl';

const Wrapper = styled.div`
  width: 235px;
  max-width: 100%;
  aspect-ratio: var(--card-aspect-ratio);
  background: center / cover no-repeat url(${discountCardBack});
`;

const message = defineMessage({
  id: 'ConversionCreditReward.arial-label',
  defaultMessage: 'Conversion reward',
});

export const BackConversionCreditReward = () => {
  const { formatMessage } = useIntlContext();
  return <Wrapper aria-label={formatMessage(message)} />;
};
